// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"64eb6d61","202":"1d3da9c4","249":"57fa0244","390":"3979d696","502":"dec4c112","637":"3918c35f","715":"9cf85de9","821":"a60d0292","828":"ecc90b28"}[chunkId] + ".chunk.css";
};